import React from "react";

const SingleLinekeyValue = ({
  label,
  value = "-",
  top = "",
  bottom = "",
  left = "0px",
  right = "0px",
  inline = false,
  title = "",
}) => {
  const containerStyle = {
    marginTop: top,
    marginRight: right,
    marginBottom: bottom,
    marginLeft: left,
    display: inline ? "inline" : "block",
  };

  const labelStyle = {
    display: "contents",
  };

  const valueStyle = {
    display: "contents",
    fontWeight: "bold",
  };

  return (
    <div style={containerStyle} title={title}>
      <span style={labelStyle}>{label}</span>:{" "}
      <span style={valueStyle}>{value}</span>
    </div>
  );
};

export default SingleLinekeyValue;
